import type { NuxtApp } from '#app';
import type { Router } from 'vue-router';
import LoginCallback from '../callback';

export class Module {
  $apiClient: NuxtApp['$apiClient'];
  $auth: NuxtApp['$auth'];
  $router: Router;
  callbackHandler: LoginCallback;

  constructor(nuxt: NuxtApp) {
    this.$apiClient = nuxt.$apiClient;
    this.$auth = nuxt.$auth;
    this.$router = nuxt.$router as Router;
    this.callbackHandler = new LoginCallback(nuxt);
  }

  get route() {
    return this.$router.currentRoute.value;
  }

  async provisionMFA(username = undefined, tenantSlug = undefined) {
    const result = await this.$apiClient.authentication.mfaOtpSetup.provision(username, tenantSlug);
    return result;
  }

  async verifyMFA(username = undefined, tenantSlug = undefined, token = undefined, { redirectTo = null } = {}) {
    await this.$auth.loginWith('local', {
      url: '/authentication/mfa_otp_setup/verify',
      method: 'post',
      body: {
        username,
        tenant_slug: tenantSlug,
        token,
      },
    });

    return this.callbackHandler.handle({ redirectTo });
  }
}

export function SetupMFA(nuxt) {
  nuxt.$auth.mfaModule = new Module(nuxt);
}
